import { render, staticRenderFns } from "./SchoolDetail.vue?vue&type=template&id=7c69d677&scoped=true&%3Akey=componentKey&"
import script from "./SchoolDetail.vue?vue&type=script&lang=ts&"
export * from "./SchoolDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolDetail.vue?vue&type=style&index=0&id=7c69d677&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c69d677",
  null
  
)

export default component.exports